var map = {
	"./Freight-BigLight.ttf": "ysFG",
	"./Freight-BigLightItalic.ttf": "QR/e",
	"./Gotham-Bold.ttf": "JtNI",
	"./Gotham-Book.ttf": "qBb1",
	"./Gotham-Medium.ttf": "vKqu"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vrtt";